import React from 'react';
import ReactDOM from 'react-dom';
import Demo from './Demo';

ReactDOM.render(<Demo />, document.querySelector('#content'));



/** WEBPACK FOOTER **
 ** ./demos/demo2-draggable-balls/index.jsx
 **/